import { Group, Paper, Stack, Text } from '@mantine/core'
import type { ReactNode } from 'react'
import type { TooltipPayload, TooltipPayloadEntry } from 'recharts'

import { formatChartLabel } from '@/utils/analytics'

export type ConversationTooltipProps = {
  label: ReactNode
  /** Null when the channel had no conversations that day, so there is no share to show */
  percentage: number | null
  payload: TooltipPayload
}

function getTooltipText(entry: TooltipPayloadEntry, percentage: number | null): string {
  switch (entry.name) {
    case 'allConversations':
      return percentage === null ? 'No conversations that day' : `${percentage.toFixed(1)}% of conversations that day`
    case 'total':
      return `${entry.value} conversations`
    case 'unique':
      return `${entry.value} unique End Users`
    default:
      return `${entry.value} ${entry.name}`
  }
}

export function ConversationByDateTooltip({ label, percentage, payload }: ConversationTooltipProps) {
  return (
    <Paper p="sm" withBorder>
      <Text fw={500} mb={5}>
        {formatChartLabel(label, true)}
      </Text>
      <Stack gap="xs">
        {payload.map(entry => (
          <Group key={entry.name} gap="sm">
            <div style={{ width: 10, height: 10, backgroundColor: entry.color, borderRadius: '50%' }} />
            <Text size="sm">{getTooltipText(entry, percentage)}</Text>
          </Group>
        ))}
      </Stack>
    </Paper>
  )
}

export function ConversationTooltip({ label, percentage, payload }: ConversationTooltipProps) {
  return (
    <Paper p="sm" withBorder>
      <Text fw={500} mb={5}>
        {label}
      </Text>
      <Stack gap="xs">
        {payload.map(entry => (
          <Group key={entry.name} gap="sm">
            <div style={{ width: 10, height: 10, backgroundColor: entry.color, borderRadius: '50%' }} />
            <Text size="sm">{getTooltipText(entry, percentage)}</Text>
          </Group>
        ))}
      </Stack>
    </Paper>
  )
}
